if (!customElements.get('smk-item-carousel-01')) {
  customElements.define('smk-item-carousel-01', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      window.setTimeout(() => {
        if (this.isConnected) this._setup();
      }, 0);
    }

    disconnectedCallback() {
      if (this._handleResize) window.removeEventListener('resize', this._handleResize);
      if (this.nextBtn && this._handleNext) this.nextBtn.removeEventListener('click', this._handleNext);
      if (this.track && this._touchStart) this.track.removeEventListener('touchstart', this._touchStart);
      if (this.track && this._touchEnd) this.track.removeEventListener('touchend', this._touchEnd);
    }

    _setup() {
      this.track = this.querySelector('.smk-item-carousel__track');
      this.nextBtn = this.querySelector('.smk-item-carousel__next');
      this.currentEl = this.querySelector('.smk-item-carousel__current-slide');
      this.totalEl = this.querySelector('.smk-item-carousel__total-slides');
      this.navLayer = this.querySelector('.smk-item-carousel__nav');
      this.items = this.querySelectorAll('.smk-item-carousel__item');
      this.totalItems = this.items.length;
      if (!this.track || !this.nextBtn || this.totalItems === 0) return;

      this.currentIndex = 0;
      this.isMobile = window.innerWidth <= 1024;
      this.initCalculations();
      this._handleNext = this.handleNext.bind(this);
      this._handleResize = this.handleResize.bind(this);
      this.nextBtn.addEventListener('click', this._handleNext);
      window.addEventListener('resize', this._handleResize);

      this.startX = 0;
      this._touchStart = (event) => { this.startX = event.touches[0].clientX; };
      this._touchEnd = (event) => {
        const difference = this.startX - event.changedTouches[0].clientX;
        if (difference > 40) this.handleNext();
        else if (difference < -40) this.handlePrev();
      };
      this.track.addEventListener('touchstart', this._touchStart, { passive: true });
      this.track.addEventListener('touchend', this._touchEnd);
    }

    initCalculations() {
      this.itemsPerSlide = this.isMobile ? 2 : 6;
      this.totalSlides = Math.ceil(this.totalItems / this.itemsPerSlide);
      if (this.currentIndex >= this.totalSlides) this.currentIndex = Math.max(0, this.totalSlides - 1);
      if (this.navLayer) this.navLayer.style.display = this.totalSlides <= 1 ? 'none' : 'flex';
      if (this.totalEl) this.totalEl.textContent = this.totalSlides;
      if (this.currentEl) this.currentEl.textContent = this.currentIndex + 1;
      this.updateSlider();
    }

    handleResize() {
      const currentlyMobile = window.innerWidth <= 1024;
      if (currentlyMobile !== this.isMobile) {
        this.isMobile = currentlyMobile;
        this.initCalculations();
      } else {
        this.updateSlider();
      }
    }

    handleNext() {
      this.currentIndex += 1;
      if (this.currentIndex >= this.totalSlides) this.currentIndex = 0;
      if (this.currentEl) this.currentEl.textContent = this.currentIndex + 1;
      this.updateSlider();
    }

    handlePrev() {
      this.currentIndex -= 1;
      if (this.currentIndex < 0) this.currentIndex = this.totalSlides - 1;
      if (this.currentEl) this.currentEl.textContent = this.currentIndex + 1;
      this.updateSlider();
    }

    updateSlider() {
      if (!this.track) return;
      if (this.totalSlides <= 1) {
        this.track.style.transform = 'translateX(0)';
        return;
      }
      const wrapperWidth = this.track.parentElement.offsetWidth;
      const distance = this.currentIndex * (wrapperWidth + 16);
      this.track.style.transform = `translateX(-${distance}px)`;
    }
  });
}
